<template>
  <applications_datatable :type="'test'"
                          :row-data="applications"
                          :loading-message="loadingMessage"
                          :no-rows-message="noRowsMessage"
                          :columns="columns"
                          :pagination-size="50"></applications_datatable>
</template>

<script>
import applications_datatable from "datatables/applications_datatable";
import {mapActions} from "vuex";

export default {
  name: "applicants",
  components: {
    applications_datatable,
    'worker_link': {
      name: 'worker_link',
      template: '<a :class="[params.data.id !== null ? \'dt_worker_link\' : \'dt_no_worker_link\']" @click="show_worker">{{params.data.full_name}}</a>',
      methods: {
        ...mapActions(['showRightInfo']),

        show_worker() {
          if (this.params.data.id !== null) {
            this.showRightInfo({data: this.params.data, type: 'workers'});
          }
        }
      }
    },
    'cv_link': {
      name: 'cv_link',
      data() {
        return {
          orca_url: process.env.MIX_APP_URL + '/'
        }
      },
      template: '<a class="view_contract_link" :href="orca_url + params.data.cv_file_path" target="_blank">CV</a>'
    },
    'order_link': {
      name: 'order_link',
      template: '<a class="dt_worker_link" @click="show_order">{{params.data.order_ref}}</a>',
      methods: {
        show_order() {
          this.$store.commit('CURRENT_ORDER_ID', this.params.data.order_job_id);
          this.$store.commit('SET_ORDER_TAB_INDEX', 0);
          this.$nextTick(() => {
            this.$router.push('/order/view');
            this.$tabs.refresh('/order/view', true)
          });
        }
      }
    },
    'advert_link': {
      name: 'advert_link',
      data() {
        return {
          web_url: process.env.MIX_WEBSITE_URL
        }
      },
      template: '<a class="view_contract_link" :href="web_url + \'find-a-job\/\orca_link\/\' + params.data.website_job_id" target="_blank">Advert</a>'
    },
    'contacted': {
      name: 'contacted',
      template: '<span>{{params.data.contacted}} ' +
          '<i class="fas fa-comments dt_worker_link ml-3" v-if="params.data.contacted !== \'Yes\'" @click="contact"></i>' +
          '</span>',
      methods: {
        contact() {
          this.$snotify.confirm('', '', {
            closeOnClick: false,
            position: 'centerCenter',
            backdrop: 0.5,
            html: '<div class="snotifyToast__title">Applicant Contacted</div>' +
                '<div class="snotifyToast__body">' +
                'Have you contacted the applicant?' +
                '<div class="snotify-icon snotify-icon--confirm"><i class="fas fa-2x fa-exclamation-triangle"></i></div>' +
                '</div>',
            buttons: [
              {
                text: 'Yes', action: (toast) => {
                  // update database
                  axios.patch(this.crmApiPath + 'applications/contacted/' + this.params.data.application_id)
                      .then(() => {
                        // refresh table contents
                        this.$bus.$emit("applications::get")
                        this.$snotify.remove(toast.id)
                      })
                }
              },
              {text: 'No', action: (toast) => this.$snotify.remove(toast.id)}
            ]
          });
        }
      }
    },
    'application_status': {
      name: 'application_status',
      template: '<span>' +
          '<i v-if="params.data.application_status === \'New\'" ' +
          'class="fas fa-thermometer-empty dt_worker_link mr-3" @click="application_status"></i>' +
          '<i v-if="params.data.application_status === \'Contacted\'" ' +
          'class="fas fa-thermometer-half dt_worker_link mr-3" @click="application_status"></i>' +
          '{{params.data.application_status}}</span>',
      methods: {
        application_status() {
          axios.get(this.crmApiPath + 'applications/' + this.params.data.application_id)
               .then(application => {
                 this.$store.commit('SHOW_APPLICANT_STATUS_CHANGE_MODAL', {
                   application: application.data,
                   applicant_dt_row_data: this.params.data
                 });
                 this.$nextTick(() => this.$root.$emit('bv::show::modal', 'change_applicant_status'));
               })
        }
      }
    },
  },
  data() {
    return {
      applications: null,
      loadingMessage: 'Loading applications',
      noRowsMessage: 'No applications found',
      columns: [
        {headerName: 'Ref', width: 90, suppressSizeToFit: true, pinned: 'left', field: 'finance_ref', sortable: false},
        {headerName: 'Name', minWidth: 150, pinned: 'left', field: 'full_name', cellRendererFramework: 'worker_link'},
        {headerName: 'Contacted', minWidth: 90, pinned: 'left', field: 'contacted', sortable: false, cellRendererFramework: 'contacted'},
        {headerName: 'Application status', minWidth: 160, field: 'application_status', cellRendererFramework: 'application_status'},
        {headerName: 'Application date', minWidth: 105, suppressSizeToFit: true, field: 'application_date', sortable: false},
        {headerName: 'Advert', minWidth: 90, sortable: false, filter: false, cellRendererFramework: 'advert_link'},
        {headerName: 'Job Ref', minWidth: 130, suppressSizeToFit: true, field: 'order_ref', cellRendererFramework: 'order_link'},
        {headerName: 'Job title', minWidth: 250, field: 'job_title'},
        {headerName: 'CV', minWidth: 60, sortable: false, filter: false, cellRendererFramework: 'cv_link'},
        {headerName: 'Mobile', minWidth: 125, field: 'mobile_number', sortable: false},
        {headerName: 'Email', minWidth: 225, field: 'email', sortable: false},
        {headerName: 'Status updated by', minWidth: 200, field: 'status_changed_by'},
        {headerName: 'Job consultant', minWidth: 200, field: 'job_consultant'},
      ]
    }
  },
  beforeMount() {
    this.get_applicants()

    this.$bus.$on("applications::get", () => this.get_applicants())
  },
  methods: {
    get_applicants() {
      return new Promise(resolve => {
        axios.get(this.crmApiPath + 'applications/index')
             .then(applications => {
               this.applications = applications.data
               resolve()
             })
      })
    }
  }
}
</script>

<style lang="scss">
.dt_worker_link {
  color: $green;

  &.focus, &:focus, &:hover, &.active, &:active, &.active.focus, &.active:focus, &.active:hover,
  &:active.focus, &:active:focus, &:active:hover {
    cursor: pointer;
    text-decoration: underline;
  }
}
.dt_no_worker_link {
  color: $bc_2 !important;
  text-decoration: none !important;
}
</style>
